var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartiallyEvaluatedSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 13H19.6C19.0165 13 18.4569 13.2318 18.0444 13.6444C17.6318 14.0569 17.4 14.6165 17.4 15.2V28.4C17.4 28.9835 17.6318 29.5431 18.0444 29.9556C18.4569 30.3682 19.0165 30.6 19.6 30.6H32.8C33.3835 30.6 33.9431 30.3682 34.3556 29.9556C34.7682 29.5431 35 28.9835 35 28.4V15.2C35 14.6165 34.7682 14.0569 34.3556 13.6444C33.9431 13.2318 33.3835 13 32.8 13ZM32.8 28.4H19.6V15.2H32.8V28.4ZM28.4 32.8V35H15.2C14.6165 35 14.0569 34.7682 13.6444 34.3556C13.2318 33.9431 13 33.3835 13 32.8V18.5H15.2V32.8H28.4ZM31.183 19.666L30.017 18.5L24.649 23.868L22.317 21.536L21.151 22.702L24.649 26.2L31.183 19.666Z",
    fill: "#848587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartiallyEvaluatedSupplyReqIcon);
export default __webpack_public_path__ + "static/media/partially-evaluated-supply-req-icon.f499a196fd511c7a05d0cc046301cd54.svg";
export { ForwardRef as ReactComponent };